/**
 * Created by vladislav on 09.08.2022
 */

const TravelBookWindow = CleverappsWindow.extend({
    ctor: function (options) {
        if (options.landmark) {
            this.landmark = options.landmark;
        }

        this._super(options);
    },

    onWindowLoaded: function (options) {
        cleverapps.travelBook.updatePages();

        this._super({
            title: Messages.get("TravelBookWindow.Title"),
            name: "travelbookwindow",
            content: this.getContent(),
            noPadding: true
        });

        if (options && options.targetPage) {
            this.showHint(options.targetPage, options.landmark);
        }
    },

    getContent: function () {
        const styles = cleverapps.styles.TravelBookWindow.content;

        const pageViews = this.pageViews = cleverapps.travelBook.listDisplayedPages().map((page) => new ExpeditionPageView(page), this);

        const content = new cleverapps.Layout(pageViews, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin,
            padding: styles.padding
        });

        const wrap = new cc.Node();
        wrap.setAnchorPoint(0.5, 0.5);
        wrap.setContentSize2(Math.max(styles.width, content.width), content.height);
        wrap.addChild(content);
        content.setAlignment(styles);

        return wrap;
    },

    showHint: function (targetId, landmark) {
        const target = this.pageViews.find((pageView) => pageView.page.id === targetId && pageView.page.isActive());

        if (target) {
            target.showHint();

            if (landmark) {
                this.showDialogue({
                    text: "TravelBook.landmarkUnlock",
                    toReplace: { name: Messages.get(target.page.title) }
                }, landmark, target);
            }
        } else {
            this.showDialogue({
                text: "MissionUnavailable"
            });
        }
    },

    showDialogue: function (text, landmark) {
        const items = landmark
            ? [Messages.get(text.text, text.toReplace), this.prepareLandmarkIcon(landmark)]
            : [Messages.get(text.text)];

        let dialogue;
        this.runAction(new cc.Sequence(
            new cc.DelayTime(0.25),
            new cc.CallFunc(() => {
                dialogue = this.dialogue = new MinimalDialogue({
                    person: "king",
                    delay: 0,
                    items,
                    rects: this.getMinimalDialogueRects()
                });
                this.addChild(dialogue);
                dialogue.display();
            }),
            new cc.DelayTime(3),
            new cc.CallFunc(() => {
                dialogue.remove();
            })
        ));
    },

    prepareLandmarkIcon: function (landmark) {
        const icon = UnitView.getUnitImage(landmark, { preferStatic: true, useLibraryAnchors: true });
        const maxIconHeight = cleverapps.UI.generateOnlyText("12345", cleverapps.styles.FONTS.FORCE_MESSAGE_TEXT).height * 1.3;

        cleverapps.UI.fitToBox(icon, {
            width: icon.width,
            height: maxIconHeight
        });

        return icon;
    },

    listBundles: function () {
        let bundles = ["travel_book"];

        if (this.landmark && this.landmark.code) {
            bundles = bundles.concat(Families.listLazyBundles(this.landmark.code));
        }

        return bundles;
    }
});

cleverapps.styles.TravelBookWindow = {
    content: {
        x: { align: "left" },
        y: { align: "center" },
        width: 1300,
        margin: 20,
        padding: {
            x: 50,
            y: 50
        }
    }
};
